<template>
<div>

<navbar></navbar>

  <div class="blocco row h100 ">

    <div class="grid h100 nav2">
    <div class="spacer xs"></div>
    <template>
        <el-select v-model="value" placeholder="Jahr auswählen">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :change="changeyear(value)">
          </el-option>
        </el-select>
      </template>
      <div class="spacer xs"></div>
      <div v-for="houses in housesgrouped">
      <p><strong>{{houses[0].size}}</strong></p>
        <p v-for="house in houses">
          <a href="#" v-on:click="showRatio(house._id, house.struktur)">{{house.struktur}} <span>{{calcratio(house._id)}}</span></a>
        </p>
      </div>
    </div>

    <div class="grid h100 w80 innercontent">
    <circle4 v-if="loading"></circle4>
    <!-- <p>{{houseratio}}</p> -->
      <h2>{{selectedhouse}} - {{value}} <!-- <span v-if="ratioquestsordered[0].finished === true">{{ratioquestsordered[0].finished}}</span> --></h2>
      <p>
        <el-button type="primary" @click="edit = true" v-if="!edit && ratioquests.length >= 1">Kennzahlen editieren</el-button>
        <el-button type="success" @click="saveRatios()" v-if="edit">Kennzahlen speichern</el-button>
        <!-- {{edit}} -->
      </p>
      <!-- <p><small>{{ratioquests}}</small></p> -->
      <table v-if="ratioquestsordered">
        <tr>
          <th>Nr</th>
          <th>Kennzahl</th>
          <th>Wert</th>
          <th>Prozent</th>
          <th>Euro</th>
          <th>aktiv</th>
        </tr>
        <tr v-for="ratioquest in ratioquestsordered" >
          <td>{{ratioquest.nr}}</td>
          <td>{{ratioquest.quest}}</td>
          <td v-if="!edit" v-bind:class="{'warning':(!ratioquest.ratioval && ratioquest.ratiovalues[0].number)}">{{ratioquest.ratioval}}</td>
          <td v-if="!edit" v-bind:class="{'warning':(!ratioquest.ratioperc && ratioquest.ratiovalues[0].perc)}">{{ratioquest.ratioperc}} <span v-if="ratioquest.ratiovalues[0].perc && ratioquest.ratioperc">%</span></td>
          <td v-if="!edit" v-bind:class="{'warning':(!ratioquest.ratioeur && ratioquest.ratiovalues[0].euro)}">{{ratioquest.ratioeur}} <span v-if="ratioquest.ratiovalues[0].euro && ratioquest.ratioeur">€</span></td>
          <td v-if="!edit && ratioquest.include" style="text-align: center;"><i class="el-icon-circle-check"></i></td>

          <td v-if="edit" v-bind:class="{'warning':(!ratioquest.ratioval && ratioquest.ratiovalues[0].number)}"><el-input placeholder="Please input" v-model="ratioquest.ratioval"></el-input></td>
          <td v-if="edit" v-bind:class="{'warning':(!ratioquest.ratioperc && ratioquest.ratiovalues[0].perc)}"><el-input placeholder="Please input" v-model="ratioquest.ratioperc"><template slot="append">%</template></el-input></td>
          <td v-if="edit" v-bind:class="{'warning':(!ratioquest.ratioeur && ratioquest.ratiovalues[0].euro)}"><el-input placeholder="Please input" v-model="ratioquest.ratioeur"><template slot="append">€</template></el-input></td>
          <td v-if="edit" style="text-align: center;"><el-checkbox v-model="ratioquest.include"></el-checkbox></td>

        </tr>
      </table>

      <!-- <p v-for="ratioquest in ratioquestsordered">{{ratioquest}}</p> -->

      <div class="spacer lg"></div>

    </div>

  </div>

</div>
</template>

<script>
  import Navbar from '@/components/Navbar'
  import {Circle4} from 'vue-loading-spinner'
  import _ from 'lodash'
  // var host = 'https://bench.node.systems'
  // var host = 'http://localhost'
  var host = process.env.ROOT_HOST
  export default {
    name: 'ratios',
    // extends: Bar,
    props: ['cat', 'chartId', 'data', 'house'],
    // props: {
    //   house: Object
    // },
    data () {
      return {
        loading: false,
        profile: JSON.parse(localStorage.profile),
        houses: '',
        edit: false,
        rat: null,
        ratioquests: '',
        selectedhouse: '',
        options: [{
          value: '2023',
          label: '2023'
        }, {
          value: '2022',
          label: '2022'
        }, {
          value: '2021',
          label: '2021'
        }, {
          value: '2020',
          label: '2020'
        }, {
          value: '2019',
          label: '2019'
        }, {
          value: '2018',
          label: '2018'
        }, {
          value: '2017',
          label: '2017'
        }, {
          value: '2016',
          label: '2016'
        }, {
          value: '2015',
          label: '2015'
        }, {
          value: '2014',
          label: '2014'
        }],
        value: '2017',
        houseratio: []
      }
    },
    components: {
      Circle4,
      Navbar
    },
    methods: {
      saveRatios () {
        console.log(this.ratioquests)
        this.loading = true
        this.$http
          .post(host + ':44534/ratios/update', { ratios: this.ratioquests },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          }
          ).then((data) => {
            // this.ombrelli = data.body.ombrells
            // this.houses = data.body.houses
            // console.log(this.houses)
            this.loading = false
            this.edit = false
          }, (error) => {
            console.log(error)
          })
      },
      changeyear: function (year) {
        // this.loading = true
        // console.log(year)
        // this.calcratio()
      },
      calcratio: function (house) {
        // this.loading = true
        if (this.value) {
          // console.log(house, this.value)
          this.$http
            .get(host + ':44534/api/ratio/' + house + '/' + this.value,
            {
              headers: {
                'Authorization': 'Bearer ' + localStorage.jwt
              }
            }
            ).then((data) => {
              // console.log(data.body.ratioquests)
              // this.rat = data.body.ratioquests.length
              // console.log(rat)
              // this.houseratio.push(data.body.ratioquests.length)
              // return data.body.ratioquests.length
            }, (error) => {
              console.log(error)
              return 2
            })
        } else {
          return 1
        }
      },
      getHouses: function () {
        // console.log(this.value)
        this.loading = true
        this.$http
          .get(host + ':44534/api/houses',
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          }
          ).then((data) => {
            // this.ombrelli = data.body.ombrells
            this.houses = data.body.houses
            // console.log(this.houses)
            this.loading = false
          }, (error) => {
            console.log(error)
          })
      },
      showRatio: function (house, struktur) {
        this.loading = true
        // console.log(this.value)
        this.$http
          .get(host + ':44534/api/ratio/' + house + '/' + this.value,
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          }
          ).then((data) => {
            // this.ombrelli = data.body.ombrells
            console.log(data.body)
            this.ratioquests = data.body.ratioquests
            this.selectedhouse = struktur
            this.loading = false
          }, (error) => {
            console.log(error)
          })
      }
    },
    beforeMount () {
      this.getHouses()
    },
    computed: {
      ratioquestsordered: function () {
        return _.orderBy(this.ratioquests, 'nr')
      },
      housesgrouped: function () {
        return _.groupBy(this.houses, 'size')
      }
    },
    mounted () {
    },
    created () {
      // this.calcratio()
    }
  }
</script>

<style>
  a {
    cursor: pointer;
  }
</style>




// WEBPACK FOOTER //
// src/components/Ratios.vue